import toolsAndFields from './fields';
import configs from './configs';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  tools: toolsAndFields,
  fields: toolsAndFields.fields.named,
  configs: configs,
};
